import * as staffsService from '@/services/system/staffs'
// import router from '@/router'

const DEFAULT_QUERY = {
  pagination: {
    current: 1,
    pageSize: 25,
    pageSizeOptions: ['10', '25', '35', '45', '100'],
    showQuickJumper: true,
    showSizeChanger: true,
  },
  filters: null,
  sorter: { field: 'created_at', order: 'descend' },
}

const DEFAULT_META = {
  total: 25,
}

const DEFAULT_DATA = {
  data: null,
  loading: false,
  query: Object.assign({}, DEFAULT_QUERY),
  meta: Object.assign({}, DEFAULT_META),
}

const DEFAULT_COMP = {
  visible: false,
  loading: false,
  processing: false,
}

/*********************
 ** STORE OBJECT
 *********************/

export default {
  namespaced: true,
  state: {
    // DATA
    staff: Object.assign({}, DEFAULT_DATA),
    staffs: Object.assign({}, DEFAULT_DATA),
    // UI
    ui: {
      CREATE_STAFF: Object.assign({}, DEFAULT_COMP),
    },
  },
  getters: {
    // Main data
    data: (state) => (key) => state[key].data,
    loading: (state) => (key) => state[key].loading,
    query: (state) => (key) => state[key].query,
    pagination: (state) => (key) => state[key].query.pagination,
    filters: (state) => (key) => state[key].query.filters,
    sorter: (state) => (key) => state[key].query.sorter,
    meta: (state) => (key) => state[key].meta,
    // Components Data
    UI_VISIBLE: (state) => (key) => state.ui[key].visible,
    UI_LOADING: (state) => (key) => state.ui[key].loading,
    UI_PROCESSING: (state) => (key) => state.ui[key].processing,
  },
  mutations: {
    INIT: (state) => {
      state.staff = state.staffs = Object.assign({}, DEFAULT_DATA)
      for (const [key, data] of Object.entries(state.ui)) {
        state.ui[key] = Object.assign({}, DEFAULT_COMP)
      }
    },
    UPDATE: (state, { key, data }) => {
      if (state[key]) state[key].data = data
    },
    SET_LOADING: (state, { key, loading }) => {
      if (state[key]) state[key].loading = loading
    },
    START: (state, key) => {
      if (state[key]) state[key].loading = true
    },
    END: (state, key) => {
      if (state[key]) state[key].loading = false
    },
    SET_QUERY: (state, { key, query }) => {
      if (state[key]) state[key].query = query || Object.assign({}, DEFAULT_QUERY)
    },
    SET_PAGINATION: (state, { key, pagination }) => {
      if (state[key]) {
        state[key].query = state[key].query || Object.assign({}, DEFAULT_QUERY)
        state[key].query.pagination = pagination
      }
    },
    SET_FILTERS: (state, { key, filters }) => {
      if (state[key]) {
        state[key].query = state[key].query || Object.assign({}, DEFAULT_QUERY)
        state[key].query.filters = filters
      }
    },
    SET_SORTER: (state, { key, sorter }) => {
      if (state[key]) {
        state[key].query = state[key].query || Object.assign({}, DEFAULT_QUERY)
        state[key].query.sorter = sorter
      }
    },
    SET_META: (state, { key, meta }) => {
      if (state[key]) state[key].meta = meta
    },
    UI_VISIBLE: (state, { key, visible }) => {
      if (state.ui[key]) state.ui[key].visible = visible
    },
    UI_LOADING: (state, { key, loading }) => {
      if (state.ui[key]) state.ui[key].loading = loading
    },
    UI_PROCESSING: (state, { key, processing }) => {
      if (state.ui[key]) state.ui[key].processing = processing
    },
  },
  actions: {
    // initialization
    init({ commit }) {
      commit('INIT')
    },
    // set pagination
    setPagination({ commit }, { key, pagination }) {
      if (pagination && pagination.current) commit('SET_PAGINATION', { key, pagination })
    },
    // set filters
    setFilters({ commit }, { key, filters }) {
      if (filters && Object.keys(filters).length) commit('SET_FILTERS', { key, filters })
    },
    // set sorter
    setSorter({ commit }, { key, sorter }) {
      if (sorter && sorter.field) commit('SET_SORTER', { key, sorter })
    },
    // set all query same time
    updateQuery({ dispatch }, { key, query: { pagination, filters, sorter } }) {
      dispatch('setPagination', { key, pagination })
      dispatch('setFilters', { key, filters })
      dispatch('setSorter', { key, sorter })
      dispatch('fetchAll', key)
    },

    /*********************
     ** STAFFS
     *********************/

    // get all data
    async fetchAll({ dispatch }, key) {
      if (key === 'staffs') {
        return await dispatch('fetchStaffs')
      }
      return null
    },

    // get staffs
    async fetchStaffs({ commit, state }) {
      commit('START', 'staffs')
      const { users: data, meta } = await staffsService.fetchStaffs(state.staffs.query)
      if (data) commit('UPDATE', { key: 'staffs', data })
      if (meta) commit('SET_META', { key: 'staffs', meta })
      commit('END', 'staffs')
      console.log(state)
      return data
    },

    // get the staff
    async fetchStaff({ commit }, id) {
      commit('START', 'staff')
      if (id) {
        const data = await staffsService.fetchStaffById(id)
        if (data) commit('UPDATE', { key: 'staff', data })
        commit('END', 'staff')
        return data
      }
      commit('END', 'staff')
      return null
    },

    // create new staff
    async createStaff({ commit, dispatch }, staff) {
      commit('START', 'staff')
      if (staff) {
        const data = await staffsService.createStaff(staff)
        if (data) commit('UPDATE', { key: 'staff', data })
        commit('UI_VISIBLE', { key: 'CREATE_STAFF', visible: false })
        dispatch('fetchStaffs')
        commit('END', 'staff')
        return data
      }
      commit('END', 'staff')
      return null
    },

    // update the staff
    async updateStaff({ commit }, staff) {
      commit('START', 'staff')
      if (staff) {
        const data = await staffsService.updateStaff(staff)
        if (data) commit('UPDATE', { key: 'staff', data })
        commit('END', 'staff')
        return data
      }
      commit('END', 'staff')
      return null
    },

    // Components Handling
    /*********************
     **  COMPONENTS
     *********************/
    UI_VISIBLE({ commit }, { key, visible }) {
      commit('UI_VISIBLE', { key, visible })
    },
    open({ commit }, key) {
      commit('UI_VISIBLE', { key, visible: true })
    },
    close({ commit }, key) {
      commit('UI_VISIBLE', { key, visible: false })
    },
  },
}
